import { render, staticRenderFns } from "./StatHeaderCell.vue?vue&type=template&id=0da08c01&scoped=true&"
import script from "./StatHeaderCell.vue?vue&type=script&lang=js&"
export * from "./StatHeaderCell.vue?vue&type=script&lang=js&"
import style0 from "./StatHeaderCell.vue?vue&type=style&index=0&id=0da08c01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da08c01",
  null
  
)

export default component.exports